/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icon_attachment': {
    width: 25,
    height: 23,
    viewBox: '0 0 25 23',
    data: '<path pid="0" d="M23.09 2.55a4.978 4.978 0 00-7.084 0L5.482 13.25a3.065 3.065 0 000 4.31 2.98 2.98 0 004.261 0l6.52-6.648a1.012 1.012 0 000-1.454.984.984 0 00-1.438 0l-6.572 6.595a.955.955 0 01-1.335 0 .982.982 0 010-1.351L17.444 4.004c1.129-1.142 3.028-1.142 4.159 0 1.129 1.142 1.129 3.064 0 4.208L11.077 18.909c-1.951 1.974-5.082 1.974-6.983 0-1.951-1.974-1.951-5.14 0-7.064L13.54 2.29a1.012 1.012 0 000-1.454.984.984 0 00-1.438 0L2.658 10.34c-2.721 2.753-2.721 7.27 0 10.024 2.721 2.753 7.187 2.753 9.908 0L23.09 9.717c1.951-1.973 1.951-5.193 0-7.167z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
